import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Avatar, Empty, Spin } from "antd";
import Styles from "../SearchPage/SearchpageStyles.module.css";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import Statistics from "./Statistics";
import { getRecentRatings, getBetterRatings, getBestRatings, getWorstRatings } from "../../API/api";
import RecentRatingCardNew from "./RecentRatingCardNew";
import { getInlineImage } from "../../API/api";
import ExpertvsCommunityStatsGraph from "../../Component/myStat/ExpertvsCommunityStatsGraph";
import { Grid } from "@mui/material";
import { ReactComponent as ThumbsUpIcon } from '../../Icons/thumbsUp.svg';
import {ReactComponent as ThumbsDownIcon} from '../../Icons/thumbDown.svg';

export default function Tabs({ onStateChange }) {
	const recommedState = useSelector((state) => state.recommend)
	const pageState = useSelector((state) => state.favouriteQuestions);
	const sharedByMeState = useSelector((state) => state.sharedBy);
	const sharedWithMeState = useSelector((state) => state.sharedWith);
	const [isTabChanged, setIsTabChanged] = React.useState(false);
	const myStatState = useSelector((state) => state.myStatsData);
	const dispatch = useDispatch()
	const { getBestQuestionsData, getWorstQuestionsData, getBetterRatingsData, loadingDataForMyStat, getRecentRatingsData, updateFavouriteSearchedQuery, updateSharedBySearchedQuery, updateSharedWithSearchedQuery } = bindActionCreators(Actions, dispatch)
	const onClickRegen = (val) => {
		setVal(val);
		onStateChange(val)
		if (val === 2) {
			getRecentRatingsForExpert();
		}
		if (val === 3) {
			getBetterRatingsAnswers();
		}
		if(val === 4)
		{
			getBestAndWorstRatings();
		}
	}

	const getBestAndWorstRatings = () => {
		loadingDataForMyStat(true);
		getBestRatings().then((res) => {
		  if (res===undefined) return;
		  if(res.response && res.response.status === 403)
		  {
			loadingDataForMyStat(false);
			getBestQuestionsData([]);
		  }
		  if (res.data.data !== undefined || res.data.success) {
			getBestQuestionsData(res.data.data);
			res.data.data.filter((obj)=>{
			  if (obj.inlineImages.length > 0) {
				getInlineImage(obj.inlineImages).then(res1 => {
				  if (res1===undefined) return;
				  for (let i = 0; i < obj.inlineImages.length; ++i) {
					if (obj.inlineImages[i].includes(".png")) {
					} else {
					  let imgTag = `<img style='max-width:50%' src=${res1.data.data[obj.inlineImages[i]]
						}></img>`;
  
					  let replacedContent = obj.inlineImages[i];
					  obj.answer = obj.answer.replaceAll(
						replacedContent,
						imgTag
					  );
					  getBestQuestionsData(res.data.data);
					}
				  }
				})
			  }
			})
		  }
		}).catch((err)=>{

		})
		getWorstRatings().then((res) => {
		  if (res===undefined) return;
		  if(res.response && res.response.status === 403)
		  {
			loadingDataForMyStat(false);
			getWorstQuestionsData([]);
		  }
		  if (res.data.data !== undefined || res.data.success) {
			getWorstQuestionsData(res.data.data);
			loadingDataForMyStat(false);
			res.data.data.filter((obj)=>{
			  if(obj.inlineImages.length > 0)
			  {
				getInlineImage(obj.inlineImages).then(res1=>{
				  if (res1===undefined) return;
				  for (let i = 0; i < obj.inlineImages.length; ++i) {
					if (obj.inlineImages[i].includes(".png")) {
					} else {
					  let imgTag = `<img style='max-width:50%' src=${
						res1.data.data[obj.inlineImages[i]]
					  }></img>`;
  
					  let replacedContent = obj.inlineImages[i];
					  obj.answer = obj.answer.replaceAll(
						replacedContent,
						imgTag
					  );
					  getWorstQuestionsData(res.data.data);
					}
				  }
				})
			  }
			})
		  }
		}).catch((err)=>{

		})
	}

	const getBetterRatingsAnswers = () => {
		loadingDataForMyStat(true)
		getBetterRatings().then((res) => {
			if (res === undefined) return;
			if(res.response && res.response.status === 403)
				{
					loadingDataForMyStat(false);
					getBetterRatingsData([]);
				}
			if (res.data.data !== undefined || res.data.success) {
				getBetterRatingsData(res.data.data);
				loadingDataForMyStat(false);	
				res.data.data.filter((obj) => {
					if (obj.inlineImages.length > 0) {
						getInlineImage(obj.inlineImages).then(res1 => {
							if (res1 === undefined) return;
							for (let i = 0; i < obj.inlineImages.length; ++i) {
								if (obj.inlineImages[i].includes(".png")) {
								} else {
									let imgTag = `<img style='max-width:50%' src=${res1.data.data[obj.inlineImages[i]]
										}></img>`;

									let replacedContent = obj.inlineImages[i];
									obj.answerText = obj.answerText.replaceAll(
										replacedContent,
										imgTag
									);
									getBetterRatingsData(res.data.data);
								}
							}
						})
					}
				})
			}
		}).catch((err)=>{

		})
	}

	const getRecentRatingsForExpert = () => {
		loadingDataForMyStat(true);
		getRecentRatings().then((res) => {
			if (res === undefined) return;
			if(res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			  getRecentRatingsData([]);
			}
			if (res.data.data !== undefined || res.data.success) {
				getRecentRatingsData(res.data.data);
				loadingDataForMyStat(false);
			}
		}).catch((err)=>{

		})
	}


	const [val, setVal] = useState(1);


	const noDataAvailable = (pageState, sharedByMeState, sharedWithMeState) => {
		return (
			<div className="trendingfilterbar" style={{ textAlign: "center" }}>
				{(pageState.isLoading === false && pageState.data.length === 0 && val === 1) && (
					<>
						<Empty />
					</>
				)}
				{(sharedByMeState.isLoading === false && sharedByMeState.data.length === 0 && val === 2) && (
					<>
						<Empty />
					</>
				)}
				{(sharedWithMeState.isLoading === false && sharedWithMeState.data.length === 0 && val === 3) && (
					<>
						<Empty />
					</>
				)}
			</div>
		);
	};

	return (
		<>
			<div className="mb-5">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: "20px",
						gap: '12px'
					}}
				>
					<div
						className={val === 1 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(1)}
						style={{ cursor: 'pointer' }}
					>
						Statistics
					</div>
					<div
						className={val === 2 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(2)}
						style={{ cursor: 'pointer' }}
					>
						Recent Ratings
					</div>
					<div
						className={val === 3 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(3)}
						style={{ cursor: 'pointer' }}
					>
						Expert vs Community Stats
					</div>
					<div
						className={val === 4 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(4)}
						style={{ cursor: 'pointer' }}
					>
						Best and Worst Answer
					</div>
				</div>
				{val === 1 && myStatState.isLoading === false && <Statistics />}
				{val === 1 && myStatState.isLoading && <Spin spinning={true} size="large" style={{display:'flex',justifyContent:'center'}} />}
				{val === 2 && myStatState.isLoading === false && myStatState.recentRatings.length > 0 && myStatState.recentRatings.map((obj, ind) => {
					return (<RecentRatingCardNew data={obj} key={ind} value={val - 1} />)
				})}
				{val === 2 && myStatState.isLoading && <Spin spinning={true} size="large" style={{ display: 'flex', justifyContent: 'center' }} />}
				{val === 2 && myStatState.isLoading === false && myStatState.recentRatings.length === 0 && <Empty />}
				{val === 3 && myStatState.isLoading && <Spin spinning={true} size="large" style={{ display: 'flex', justifyContent: 'center' }} />}
				{myStatState.isLoading === false && val === 3 && <ExpertvsCommunityStatsGraph />}
				{val==3 && myStatState.isLoading === false && <h4 style={{ fontSize: "18px", textAlign: "center", marginTop: "20px", fontWeight: "bold", marginBottom: "12px",color:'#2A364A' }}>Answers with better ratings</h4>}
				{val === 4 && (
					<Grid container paddingTop={0} columnSpacing={2}>
						<Grid item lg={6} xl={6} md={12} xs={12} sm={12}>
							<h2 style={{fontSize:'21px',color:'rgb(92, 102, 123)',textAlign:'center'}}><ThumbsUpIcon width={24} height={24} style={{marginRight:'5px',marginBottom:'7px'}} />Best Answers in the last 30 days</h2>
							{myStatState.isLoading === false && myStatState.bestRatingsData.length === 0 &&(<><Empty /></>)}
							{myStatState.isLoading && <Spin size="large" style={{display:'flex',justifyContent:'center'}} spinning={true} />}
							{myStatState.isLoading === false && myStatState.bestRatingsData.length > 0 && myStatState.bestRatingsData.map((obj,ind)=>{
								return(<RecentRatingCardNew data={obj} key={ind} value={val - 1} />)
							})}
							</Grid>
						<Grid item lg={6} xl={6} md={12} xs={12} sm={12}>
						<h2 style={{fontSize:'21px',color:'rgb(92, 102, 123)',textAlign:'center'}}><ThumbsDownIcon width={24} height={24} style={{marginRight:'5px',marginTop:'5px'}} />Worst Answers in the last 30 days</h2>
						{myStatState.isLoading === false && myStatState.worstRatingsData.length === 0 && <Empty />}
						{myStatState.isLoading && <Spin size="large" style={{display:'flex',justifyContent:'center'}} spinning={true} />}
						{myStatState.isLoading === false && myStatState.worstRatingsData.length > 0 && 
						myStatState.worstRatingsData.map((obj,ind)=>{
							return(<RecentRatingCardNew value={val-1} data={obj} key={ind} />)
						})}
						</Grid>
					</Grid>
				)}
				{
					val === 3 && myStatState.isLoading === false && myStatState.betterRatingsData.length > 0 && myStatState.betterRatingsData.map((data, index) => {
						return (
							<>
								<RecentRatingCardNew value={val - 1} data={data} key={index} />
							</>
						)
					})
				}
				{
					myStatState.isLoading === false && myStatState.betterRatingsData.length === 0 && val===3 && (
						<Empty />
					)
				}
			</div>
		</>
	);
}